import React from "react";
import styled from "styled-components";
import { ReactComponent as Curtain } from "images/svg/heroCurtain.svg";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import PrimaryButton from "components/buttons/primary-button";
import { useNavigate } from "react-router-dom";
import HeroLottie from "animation/hero-lottie";

const Hero = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <CuratinContainer>
        <Curtain />
      </CuratinContainer>

      <HeaderSection>
        <TrustedContainer>
          <Typography size="s" m_size="xs" mr="0.4">
            Trusted by Artists
          </Typography>
          <Typography
            size="s"
            mr="0.4"
            color={Colors.yellow400}
            weight="semibold"
            m_size="xs"
          >
            50,000+
          </Typography>
          <Typography size="s" m_size="xs">
            {" "}
            Artists
          </Typography>
        </TrustedContainer>
        <Typography
          color={Colors.white100}
          size="4.8rem"
          weight="bold"
          align="center"
          mb="1.6"
          m_size="2.8rem"
        >
          Your Music, Worldwide. No Barriers.
        </Typography>
        <Typography align="center" size="xl" m_size="m" mb="3.2">
          Everything you need to share your music globally, earn royalties, and
          connect with fans.
        </Typography>
        <PrimaryButton
          text="Get Access"
          inset
          sparkle
          fitContent
          onClick={() => navigate("/create-account")}
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M3.33398 10H16.6673M16.6673 10L11.6673 5M16.6673 10L11.6673 15"
                stroke="#131313"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          }
          iconPosition="right"
          iconSize="2"
        />
      </HeaderSection>
      <AnimationContainer>
        <HeroLottie />
      </AnimationContainer>
    </Container>
  );
};

export default Hero;

const Container = styled.div`
  min-height: 98.2rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 769px) {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }
`;

const CuratinContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  /* height: 100%; */
  z-index: 0;
`;

const HeaderSection = styled.div`
  margin-top: 15.8rem;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  @media only screen and (max-width: 769px) {
    margin-top: 5.8rem;
  }
`;

const TrustedContainer = styled.div`
  margin-bottom: 1.6rem;
  padding: 0.8rem 1.2rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 1.2rem;
  border: 0.5px solid ${Colors.white100};
  display: inline-flex;
  @media only screen and (max-width: 769px) {
    padding: 0.6rem 0.8rem;
  }
`;

const AnimationContainer = styled.div`
  margin-top: 9.6rem;
  width: 120rem;
  margin-left: auto;
  margin-right: auto;
  @media only screen and (max-width: 769px) {
    width: 100%;
    /* margin-top: -7rem; */
  }
`;
